import { catchRestError, MSystemGet, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { startOfMonth } from "services/DateService";
import { PageableResponse } from "../PageableResponse";

// 当月取得処理
export const B010080TogetsuYm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  await MSystemGet()
    .then((response) => {
      const firstYmd = startOfMonth(response.data.togetsuYm);
      // 受注日の範囲(開始)初期設定
      methods.setValue("juchuYmdFrom", firstYmd);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("juchuYmdFrom", "");
    });
};

export type B010080FindRequest = Partial<{
  juchuYmdFrom: string;
  juchuYmdTo: string;
  shukayoteiYmdFrom: string;
  shukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  chumonNo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  assistantCd: string;
  janCd: string;
  shohinCd: string;
  shohinshubetsuKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B010080FindResponse = {
  juchuYmd: string;
  juchudenpyoNo: string;
  juchuKbn: string;
  tokuiNm: string;
  shukayoteiYmd: string;
  meigyosu: string;
  juchuKin: string;
  biko: string;
};

// 検索メソッド
export const B010080Find = (props: B010080FindRequest) => {
  return RestClient.get<PageableResponse<B010080FindResponse>>("b010080/find", {
    params: props,
  });
};

export type B010080JuchudenpyoNo = {
  juchudenpyoNo: string | undefined;
  version: string | undefined;
};

export type B010080UpdateRequest = Partial<{
  juchudenpyoNoList: B010080JuchudenpyoNo[];
}>;

// 更新処理
export const B010080Update = (props: B010080UpdateRequest) => {
  return RestClient.put("b010080/update", props);
};
